import { FunctionComponent, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useOktaAuth } from '@okta/okta-react';

const Logout: FunctionComponent = () => {

    const history = useHistory();
    const { oktaAuth } = useOktaAuth();

    useEffect(() => {
        const isExtAuth = sessionStorage.getItem("isExtAuth");
        if (isExtAuth) {
            sessionStorage.removeItem("isExtAuth");
            setTimeout(() => {
                window.close();
            }, 2000);
        }
    }, [oktaAuth]);

    const signin = () => {
        history.push("/");
    }

    return (
        <div className="page-container">

            <div className="logo" />

            <div className="tick-wrapper">
                <div className="tick-circle">
                    <div className="tick-checkMark"></div>
                </div>
            </div>

            <h3>Logged Out</h3>

            <p>You have been successfully logged out of the Panviva Sidekick.</p>

            <button className='sign-in-button btn btn-primary' onClick={signin}>Sign In</button>

        </div>
    );
}

export default Logout;